// Translates an enum-style value emitted by an API through a locale dictionary
// if the value is recognized, falling back to the raw value (or a default)
// otherwise. Centralizes the `KNOWN_*.has(v) ? t(`scope.${v}`) : v ?? fallback`
// pattern so consumers (currently OverviewTab's resolution/escalation/timeline
// rows) don't re-implement it per call site.
//
// Behavior:
//  - value is null/undefined/empty → returns `fallback` (or '' if not given)
//  - value is in `known`           → returns `t('${scope}.${value}')`
//  - value is non-null but unknown → returns the raw value (so a new backend
//                                    enum value surfaces something readable
//                                    instead of a missing-translation key)
//
// `t` is passed in rather than imported because callers have a scene-scoped
// `t = buildTranslate(...)` instance; the scope arg here is appended onto
// that caller's scope.
export const translateEnum = (
  known: ReadonlySet<string>,
  value: string | null | undefined,
  t: (key: string) => string,
  scope: string,
  fallback = ''
): string => {
  if (!value) return fallback
  return known.has(value) ? t(`${scope}.${value}`) : value
}
